module.exports = __webpack_public_path__ + "img/mercantil-do-brasil.212cd9af.svg";